<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex gap-2">
          <h2 class="mb-0">Vendors</h2>
          <jni-spinner *ngIf="showLoader"></jni-spinner>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <!-- <p-popover #importOverlay>
            
          </p-popover> -->

          <!-- <p-togglebutton
            onLabel="Filter"
            offLabel="Filter"
            onIcon="pi pi-filter-fill"
            offIcon="pi pi-filter"
            styleClass="w-36 "
            ariaLabel="Do you confirm"
            severity="secondary"
            class="fullwdth secondary-btn btn-primecolor" /> -->

          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />

          <p-button
            label="New Vendor"
            icon="pi pi-plus"
            (click)="onVendorRedirection()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-lg-12">
        <p-table
          #dt
          stripedRows
          [value]="vendorListings"
          [(selection)]="selectedVendors"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [resizableColumns]="true"
          [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0"
          selectionMode="multiple"
          styleClass="table-listing"
          [lazy]="true"
          (onLazyLoad)="getAllVendorsListingData($event)"
          [totalRecords]="totalRecords">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th class="max-width-5">Vendor Number</th>
              <th class="max-width-8">Rating</th>
              <th class="max-width-7">Group</th>
              <th class="max-width-10">Name</th>
              <th class="max-width-6">Vendor Hold</th>
              <th class="max-width-6">Known as</th>
              <th class="max-width-6">Phone</th>
              <th class="max-width-6">City</th>
              <th class="max-width-4">State</th>
              <th class="max-width-4">Country</th>
            </tr>
            <tr>
              <th></th>
              <th class="max-width-5">
                <div class="d-flex">
                  <!--<input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="vendorAccountNumber"
                    id="vendorAccountNumber"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'vendorAccountNumber',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />-->
                  <p-columnFilter
                    type="text"
                    field="vendorAccountNumber"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-8"></th>
              <th class="max-width-7">
                <div class="d-flex">
                  <!--<input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="vendorGroup"
                    id="vendorGroup"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'vendorGroup',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />-->
                  <p-columnFilter
                    type="text"
                    field="vendorGroup"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-10">
                <div class="d-flex">
                  <!--<input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="vendorName"
                    id="vendorName"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'vendorName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />-->
                  <p-columnFilter
                    type="text"
                    field="vendorName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-6"></th>
              <th class="max-width-6"></th>
              <th class="max-width-6"></th>
              <th class="max-width-6"></th>
              <th class="max-width-4"></th>
              <th class="max-width-4"></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-vendorListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="vendorListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  [disabled]="false"
                  [value]="vendorListing"
                  [pSelectableRow]="vendorListing"
                  (click)="checkboxSelection()"></p-tableCheckbox>
              </td>
              <td
                (click)="getCurrentVendor(vendorListing.vendorAccountNumber)"
                class="max-width-5">
                <a class="link">{{ vendorListing.vendorAccountNumber }}</a>
              </td>

              <td class="max-width-8">
                <div class="d-flex align-items-center gap-3">
                  <p-rating
                    [stars]="5"
                    name="overallScore"
                    id="overallScore"
                    [readonly]="true"
                    class="star-rating overall ms-2"
                    [(ngModel)]="vendorListing.vendorFeedback.totalRating"
                    (mouseenter)="op.toggle($event)"></p-rating>
                  <span
                    class="rating-number"
                    *ngIf="vendorListing.vendorFeedback.vendorFeedbacks"
                    >{{
                      vendorListing.vendorFeedback.vendorFeedbacks.length
                        | number
                    }}</span
                  >
                </div>
                <p-popover #op>
                  <jni-vendor-feedback-rating
                    *ngIf="
                      vendorListing?.vendorFeedback?.vendorFeedbacks?.length > 0
                    "
                    [vendorFeedbackObject]="
                      vendorListing?.vendorFeedback?.vendorFeedbacks
                    "
                    [vendorFeedbackHeading]="'Feedback review'"
                    class="ratings-box overall ms-2"
                    [disabledToggle]="true">
                  </jni-vendor-feedback-rating>
                </p-popover>
              </td>

              <td class="max-width-7">
                {{ vendorListing.vendorGroup }}
              </td>
              <td class="max-width-10">
                {{ vendorListing.vendorName }}
              </td>
              <td class="max-width-6"></td>
              <td class="max-width-6">
                {{ vendorListing.vendorKnownAs }}
              </td>
              <td class="max-width-6">
                {{ vendorListing.phoneNumber }}
              </td>
              <td class="max-width-6">
                {{ vendorListing.city }}
              </td>
              <td class="max-width-4">
                {{ vendorListing.state }}
              </td>
              <td class="max-width-4">
                {{ vendorListing.country }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No vendors found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="vendorDisplayModal"
  [displayModal]="vendorDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Vendor Summary</h1>
  <div class="panelBody">
    <jni-vendor-summary
      [vendorIdFromModal]="vendorAccountNumber"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (emitcloseVendorModalStacker)="closeModal()"></jni-vendor-summary>
  </div>
</jni-modal-stacker>
